// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md style="margin-bottom:100px;">
    <v-row wrap>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'organizations'"
        editRoute="organizationEdit"
        :headers="headers"
        name="Organization"
        :searchBarText="searchBarText"
        permissions="organizations"
        extendedFab
        extendedFabText="New Organization"
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'

import {ENDPOINT} from '@/shared/constants'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Subdomain',
          value: 'subdomain',
          sortable: true
        },
        {
          text: 'Created',
          value: 'timeCreated',
          sortable: true
        },
        {
          text: 'Status',
          value: 'status',
          sortable: true
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Organizations.vue?415eaff2